import { createClientAxiosInstance } from '@fuxi/common-utils';
import '../../constants/login.js';
import '../../constants/activity.js';
import '../../constants/common.js';
import { LANG_LOCAL_STORAGE_KEY } from '../../constants/locale.js';
import { RBAC_BASE_URL } from '../../constants/request.js';
import 'js-cookie';
import 'validator';
import '../../utils/serverTime.js';
import 'crypto-js/sha256';
import 'crypto-js/enc-base64';
import 'crypto-js/hmac-sha256';
import { rbacErrorHandler } from '../../utils/rbacErrorHandler.js';

// 内置的 RBAC 请求封装使用
const { GateWayInstance: RbacGateWayInstance } = createClientAxiosInstance({
    baseUrl: RBAC_BASE_URL,
    envGateWayBaseUrl: '',
    secret: '',
    username: '',
    apiKey: '',
    errorHandler: rbacErrorHandler,
    extraConfig: {
        localStorageLangKey: LANG_LOCAL_STORAGE_KEY,
    },
});

export { RbacGateWayInstance };
